import script from "./ExcessView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcessView.vue?vue&type=script&setup=true&lang=ts"

import "./ExcessView.vue?vue&type=style&index=0&id=241280b2&lang=less"

const __exports__ = script;

export default __exports__